import Slider from './slider'; // Import the Slider class
import { filterNavDirect } from './filterNavDirect';
import { initializeImageSlider } from './productPageSlider';
import { dropDownEnableDisable } from './dropDown';
import {
  createProductSend,
  forgotPasswordSend,
  login,
  postReview,
  resetPasswordSend,
  signUp,
  updateDetails,
} from './login';
import { handlePayments } from './payments';
import { showError } from './showError';
import { sendDeliveryStatus, sendUpdateTrackRequest } from './orderRequests';

// DOM Elements check
const slider = document.querySelector('.image-slider');
const filters = document.querySelector('.filters');
const nextSlide = document.querySelector('.next');
const dropDown = document.querySelector('.dropdown-menu');
const loginBtn = document.querySelector('.login-btn');
const signupBtn = document.querySelector('.btn-signup');
const reviewContainer = document.querySelector('.add-review-container');
const upd = document.querySelector('.account-actions');
const forgotPassword = document.querySelector('.forgot-password-container');
const resetPassword = document.getElementById('reset-pass-btn');
const admin = document.querySelector('.admin-container');
const cartBody = document.querySelector('.cart-body');
const checkoutBtn = document.querySelector('#checkout-btn');
const logoutBtn = document.getElementById('btn-logout');

// VARIABLE DECLARATION
let dropStatus = false;

// EXECUTION FUNCTIONS
if (slider) {
  document.addEventListener('DOMContentLoaded', () => {
    const slider = new Slider('.slider-container', 3000); // 3000ms for automatic slide transition
  });

  if (window.innerWidth < 768) {
    function sliderclick() {
      console.log('slider clicked');
      nextSlide.click();
    }
    setInterval(sliderclick, 3500);
  }
}

if (filters) {
  filterNavDirect();
}

// Initialize image sliders on page load
initializeImageSlider();

// DROPDOWN MENU
if (dropDown) {
  const dropLinks = document.querySelectorAll('.nav-drop-link-mob');
  console.log(dropStatus);

  dropDown.addEventListener('click', () => {
    dropStatus = dropDownEnableDisable(dropStatus);
    console.log(dropStatus);
  });

  dropLinks.forEach((lnk) => {
    lnk.addEventListener('click', () => {
      dropStatus = dropDownEnableDisable(true);
      console.log(dropStatus);
    });
  });
}

// LOGIN
if (loginBtn) {
  loginBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const email = document.querySelector('#email').value;
    const password = document.querySelector('#password').value;
    login(email, password);
  });
}

// SIGNUP
if (signupBtn) {
  signupBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const detObj = {
      name: document.querySelector('#name').value,
      email: document.querySelector('#email').value,
      phoneNo: document.querySelector('#phoneNo').value,
      password: document.querySelector('#password').value,
      passwordConfirm: document.querySelector('#passwordConfirm').value,
    };
    signUp(detObj);
  });
}

// REVIEW SECTION
if (reviewContainer) {
  const reviewBtn = document.querySelector('#review-submit');
  reviewBtn.addEventListener('click', (e) => {
    e.preventDefault();
    console.log(e.target.dataset.id);
    const reviewInfo = {
      product: e.target.dataset.id,
      text: document.querySelector('#review-text').value,
      rating: document.querySelector('#review-rating').value,
    };
    postReview(reviewInfo);
  });
}

// UPDATE DETAILS
if (upd) {
  const updBtn = document.querySelector('#btn-save-acc-changes');
  updBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const email = document.querySelector('#email').value;
    const phoneNo = document.querySelector('#phoneNo').value;
    updateDetails({ email, phoneNo });
  });
}

// FORGOT PASSWORD
if (forgotPassword) {
  const forgotBtn = document.getElementById('forgot-btn');
  forgotBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const email = document.getElementById('email').value;
    forgotPasswordSend(email);
  });
}

// RESET PASSWORD
if (resetPassword) {
  resetPassword.addEventListener('click', (e) => {
    e.preventDefault();
    const password = document.getElementById('new-password').value;
    const passwordConfirm = document.getElementById('confirm-password').value;

    const tokenValue = window.location.pathname.split('/').slice(-1)[0];
    resetPasswordSend(tokenValue, password, passwordConfirm);
  });
}

if (admin) {
  document
    .getElementById('productForm')
    .addEventListener('submit', async (e) => {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData();

      // Append Form Fields
      [
        'name',
        'description',
        'category',
        'subCategory',
        'originalPrice',
        'discountedPrice',
        'color',
      ].forEach((field) => {
        const valAppend =
          form[field].value === 'Select' ? '' : form[field].value;
        formData.append(field, valAppend);
      });

      // console.log([...formData.entries()]);

      // Append Cover Image
      const coverImage = form.coverImage.files[0];
      if (!coverImage) return alert('Cover image is required');
      formData.append('coverImage', coverImage);

      // Append Product Images
      const images = [
        form.image1.files[0],
        form.image2.files[0],
        form.image3.files[0],
      ].filter(Boolean);
      if (images.length === 0)
        return alert('At least one product image is required');
      images.forEach((img) => formData.append('images', img));

      await createProductSend(formData);
    });
}

// PAYMENT INTEGRATION
if (checkoutBtn) {
  const addressInput = document.getElementById('address-input');
  const API_KEY = 'pk.075e6f9999e58850b1ab6fb7add2e73e';

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;

      const res = await fetch(
        `https://us1.locationiq.com/v1/reverse?key=${API_KEY}&lat=${latitude}&lon=${longitude}&format=json&`,
      );
      const data = await res.json();
      addressInput.value = data.display_name;
    },
    () => {
      console.log('loc unavaliable');
    },
    {
      enableHighAccuracy: true, // Request high accuracy
      timeout: 5000, // Set a timeout for the request
      maximumAge: 0, // Ensure the position is freshly obtained
    },
  );

  checkoutBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    const addressVal = addressInput.value;
    const products = JSON.parse(localStorage.getItem('cart')).map(
      function (product) {
        return { product: product.id, quantity: product.quantity };
      },
    );
    if (!products) showError('Cart is empty', '0px');
    else if (!addressVal) showError('Please enter address for checkout', '0px');
    else handlePayments(products, addressVal);
  });
}

// LOGOUT
if (logoutBtn) {
  logoutBtn.addEventListener('click', async (el) => {
    const res = await axios({
      method: 'POST',
      url: '/api/v1/users/logout',
    });
    if (res.data.status === 'success') {
      window.setTimeout(() => location.assign('/'), 1500);
    }
  });
}

// SEARCH FUNCTIONALITY
const searchBtn = document.getElementById('btn-search');
if (searchBtn) {
  searchBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const searchQuery = document.getElementById('search-query').value;
    if (!searchQuery) {
      showError('Please enter products to search');
    } else window.location.href = `/search/${searchQuery}`;
  });
}

// ORDER -FRONTEND
const updateBtn = document.querySelectorAll('.update-track');
if (updateBtn) {
  updateBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const orderid = btn.dataset.orderid;

      const orderCard = btn.closest('.order-card');
      const trackingLink = orderCard.querySelector('#track-input-link').value;
      const trackingId = orderCard.querySelector('#track-input-id').value;

      if (!orderid || !trackingId || !trackingLink) {
        showError('Order Update Credentials Missing', '0');
        return;
      }
      sendUpdateTrackRequest(orderid, trackingId, trackingLink);
    });
  });
}

const updateDel = document.querySelectorAll('.update-del-status');
if (updateDel) {
  updateDel.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const orderid = btn.dataset.orderid;
      sendDeliveryStatus(orderid);
    });
  });
}

// ✅ Centralized Cart Manager
const Cart = {
  get() {
    return JSON.parse(localStorage.getItem('cart')) || [];
  },
  set(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  },
  add(product) {
    let cart = this.get();
    const index = cart.findIndex((item) => item.id === product.id);
    if (index !== -1) {
      cart[index].quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }
    this.set(cart);
  },
  updateQuantity(id, change) {
    let cart = this.get();
    const index = cart.findIndex((item) => item.id === id);
    if (index !== -1) {
      cart[index].quantity += change;
      if (cart[index].quantity <= 0) cart.splice(index, 1);
    }
    this.set(cart);
  },
  remove(id) {
    let cart = this.get().filter((item) => item.id !== id);
    this.set(cart);
  },
  clear() {
    localStorage.removeItem('cart');
  },
};

// ✅ UI Render Function
function renderCart() {
  const cartItemsContainer = document.getElementById('cart-items');
  const cartTotal = document.querySelector('.cart-value');
  const cartCount = document.querySelector('.cart-count');
  const cart = Cart.get();

  let total = 0;
  let html = '';

  if (cart.length === 0) {
    html = '<p>Your cart is empty.</p>';
  } else {
    cart.forEach((item) => {
      total += item.discountedPrice * item.quantity;
      html += `
        <div class="cart-item" data-id="${item.id}">
          <img class="product-image" src="/img/products/${item.coverImage}" alt="${item.name}">
          <div class="cart-details">
            <h4>${item.name}</h4>
            <p>₹${item.discountedPrice}</p>
            <div class="cart-controls">
              <button class="cart-btn minus-btn btn-decrease">-</button>
              <span class="quantity">${item.quantity}</span>
              <button class="cart-btn plus-btn btn-increase">+</button>
              <button class="btn btn-danger btn-remove">Remove</button>
            </div>
          </div>
        </div>
      `;
    });
  }

  if (cartItemsContainer) cartItemsContainer.innerHTML = html;
  if (cartTotal) cartTotal.innerText = `Total: ₹${total.toFixed(2)}`;
  if (cartCount)
    cartCount.innerText = cart.reduce((acc, item) => acc + item.quantity, 0);
}

// ✅ Event Listeners
document.addEventListener('DOMContentLoaded', () => {
  renderCart();
});

document.addEventListener('click', (e) => {
  // Add to cart
  if (e.target.classList.contains('add-to-cart')) {
    const productData = JSON.parse(e.target.dataset.productinfo);
    Cart.add(productData);
    e.target.innerText = 'Added!';
    renderCart();
  }

  // Cart quantity increase
  if (e.target.classList.contains('btn-increase')) {
    const id = e.target.closest('.cart-item').dataset.id;
    Cart.updateQuantity(id, 1);
    renderCart();
  }

  // Cart quantity decrease
  if (e.target.classList.contains('btn-decrease')) {
    const id = e.target.closest('.cart-item').dataset.id;
    Cart.updateQuantity(id, -1);
    renderCart();
  }

  // Remove item
  if (e.target.classList.contains('btn-remove')) {
    const id = e.target.closest('.cart-item').dataset.id;
    Cart.remove(id);
    renderCart();
  }
});
